/**
 * @generated SignedSource<<e6091b7b8d81c28bee30818eff9138d7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SendNotesModal_IncludeAISummaryFormField_note$data = {
  readonly meetingRecordings: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"utils_useLongestMeetingRecording_meetingRecordings">;
  }> | null;
  readonly " $fragmentType": "SendNotesModal_IncludeAISummaryFormField_note";
};
export type SendNotesModal_IncludeAISummaryFormField_note$key = {
  readonly " $data"?: SendNotesModal_IncludeAISummaryFormField_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"SendNotesModal_IncludeAISummaryFormField_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SendNotesModal_IncludeAISummaryFormField_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingRecording",
      "kind": "LinkedField",
      "name": "meetingRecordings",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "utils_useLongestMeetingRecording_meetingRecordings"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "04e1a2bf09000bb442ff253717c6243a";

export default node;
